<template>
  <div
    id="jbContainer"
    ref="jbContainer"
    class="jb-container"
  />
</template>

<script>

export default {
  name: 'VideoFlv',
  props: {
    videoUrl: {
      type: String,
      required: true,
      default: ''
    }
  },
  data () {
    return {
      jessibuca: null
    };
  },
  computed: {
  },
  methods: {
    createJessibuca (options) {
      const _this = this;
      options = options || {};
      this.jessibuca = new window.Jessibuca(
        Object.assign(
          {
            container: _this.$refs.jbContainer,
            videoBuffer: Number('0.2'), // 缓存时长
            decoder: process.env.BASE_URL + 'video/decoder.js', // 解码器文件路径
            isResize: false, // 是否自适应等比长宽
            useWCS: false,
            useMSE: true,
            loadingText: '', // 加载中文本
            background: '', // 背景图片
            hasAudio: false, // 是否有音频
            isNotMute: true, // 是否静音
            debug: false, // 是否开启日志打印
            supportDblclickFullscreen: true, // 是否支持双击全屏
            showBandwidth: false, // 显示网速
            timeout: 10, // 超时时间
            operateBtns: {
              fullscreen: false, // 全屏按钮
              screenshot: false // 截图按钮
            }
          },
          options
        )
      );
    }
  },
  watch: {
    videoUrl (url) {
      if (!url && this.jessibuca) {
        this.jessibuca.destroy();
        this.jessibuca = null;
      } else {
        if (!this.jessibuca) {
          this.createJessibuca();
        }
        this.jessibuca.play(url);
      }
    }
  },
  created () {
  },
  mounted () {
    this.createJessibuca();
    window.onerror = (msg) => (this.err = msg);
    if (this.jessibuca && this.videoUrl) {
      this.jessibuca.play(this.videoUrl);
    }
  },
  destroyed () {
    if (this.jessibuca) {
      this.jessibuca.destroy();
    }
  }
};
</script>

<style scoped>
.jb-container {
  background: url('/monitor/images/hj/hz_mr.png');
  background-size: 100% 100%;
}
</style>
